export enum IntegrationTypeEnum
{
    FastMedic = 1,
    IT4D = 2,
}